import { Component, OnInit, OnDestroy } from '@angular/core';
import { Tender } from 'toolbandi-ui-lib';
import { CrudService, MessageService, SharedDataService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-tender-edit',
	templateUrl: './tender-edit.component.html',
	styleUrls: ['./tender-edit.component.scss']
})
export class TenderEditComponent implements OnInit, OnDestroy {

	loading: boolean = true;
	tender: Tender;

	title: string;

	constructor(
		private tenderService: CrudService<Tender>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private activeModal: NgbActiveModal,
	) { }

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.tender = new Tender();
				this.title = 'tender-create';
				this.loading = false;
			}

		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.tenderService.getEntity(Tender, 'tender', id).subscribe(tender => {
			this.tender = tender;
			this.title = 'tender-edit';
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.tender'));
			this.tender = undefined;
			this.loading = false;
		});
	}

	dismiss() {
		this.activeModal.dismiss();
	}

	submit() {

		this.fixTender();

		if (!this.tender.id) {

			this.tenderService.createEntity(Tender, 'tender', this.tender).subscribe(response => {
				this.tender = response;
				const messages = this.translateService.instant(['labels.tender-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.tender-save-success'], messages['labels.success']);
				this.activeModal.close(this.tender);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.tenderService.saveEntity(Tender, 'tender', this.tender).subscribe(response => {
				this.tender = response;
				const messages = this.translateService.instant(['labels.tender-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.tender-save-success'], messages['labels.success']);
				this.activeModal.close(this.tender);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

	fixTender(): void {

		this.tender.microent = this.tender.microent ? +this.tender.microent : 0;
		this.tender.smallent = this.tender.smallent ? +this.tender.smallent : 0;
		this.tender.mediument = this.tender.mediument ? +this.tender.mediument : 0;
		this.tender.largeent = this.tender.largeent ? +this.tender.largeent : 0;

	}

}
